// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?v=" + {"8931":"2f6b07311df0d12d0fff","9160":"d7ad167e1dcc38bae163"}[chunkId] + "";
};